// extracted by mini-css-extract-plugin
export default {"imageWrapper":"j5NlC","sizeS":"RP1kZ","image":"Nt7Hg","landscape":"ia3pd","sizeM":"ywvbN","cnImage":"MCj4M"};